import { render, staticRenderFns } from "./CtrlDesignacaoPage.vue?vue&type=template&id=a3ee662c"
import script from "./CtrlDesignacaoPage.vue?vue&type=script&lang=js"
export * from "./CtrlDesignacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports